import "@kluntje/polyfills/modern";
import { App } from "Core/App";

window._fraApp = new App(); // initialize App

declare global {
  interface Window {
    _fraViewportObserver: any;
    _fraCookieService: any;
    _fraApp: App;
    _satellite: any;
    dataLayer: any;
    fraportTraveli18n: string;
    _fraI18nService: any;
  }
}
